import React from "react";

const LOGO_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_admission-tracker-30/artifacts/1v79f7v4_IMG_1117.png";

export default function Logo({ size = 40, withWordmark = false, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="mer-logo">
      <img
        src={LOGO_URL}
        alt="MER Educational Consultancy"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        draggable={false}
      />
      {withWordmark && (
        <div className="leading-tight">
          <div className="font-display font-semibold text-[15px] text-[#0B192C]">MER</div>
          <div className="text-[10px] uppercase tracking-widest text-slate-500">
            Educational Consultancy
          </div>
        </div>
      )}
    </div>
  );
}
